import React, { Component } from "react";
import PropTypes from "prop-types";
import "../style/Pricing.css";

class Pricing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pricingPlan: 0,
      descriptions: ["The subscription model could hardly be easier:"],
      prices: [20]
    };
    this.updatePricingPlan = this.updatePricingPlan.bind(this);
  }
  givePricingPlanToParent() {
    let { pricingPlan } = this.state;
    // If you're messing around, we'll change it here
    // and in the server
    if (pricingPlan > 3 || pricingPlan < 0) {
      pricingPlan = 0;
    }
  }
  updatePricingPlan(num) {
    const { prices } = this.state;
    console.log(prices[num]);
    this.props.setPaymentOption(prices[num]);
    return this.setState({ pricingPlan: num });
  }
  render() {
    const { prices, pricingPlan, descriptions } = this.state;
    return (
      <section className="pricing-container">
        <div className="description">
          <p>{descriptions[pricingPlan]}</p>
        </div>
        <div className="">
          <p onClick={() => this.updatePricingPlan(0)} className={``}>
            One-time payment of: <span className="price">${prices[0]}</span>
          </p>
          {/* <p
            onClick={() => this.updatePricingPlan(1)}
            className={`${
              pricingPlan === 1 ? "pricing-options--selected" : ""
            }`}
          >
            Small parish <span className="price">${prices[1]}</span>
          </p>
          <p
            onClick={() => this.updatePricingPlan(2)}
            className={`${
              pricingPlan === 2 ? "pricing-options--selected" : ""
            }`}
          >
            Medium parish: <span className="price">${prices[2]}</span>
          </p>
          <p
            onClick={() => this.updatePricingPlan(3)}
            className={`${
              pricingPlan === 3 ? "pricing-options--selected" : ""
            }`}
          >
            Large parish: <span className="price">${prices[3]}</span>
          </p> */}
        </div>
      </section>
    );
  }
}

Pricing.propTypes = {
  setPaymentOption: PropTypes.func.isRequired
};

export default Pricing;



// WEBPACK FOOTER //
// ./src/components/Pricing.js